/**
 * Brug tussen de api-laag en de toasts voor een 403 `ROLE_NOT_ASSIGNED`.
 *
 * De gebruiker is ingelogd maar heeft (nog) geen rol in de HR-portal. Dat is
 * geen reden om uit te loggen — de oude 401 zette hem in een uitloglus die
 * zichzelf nooit herstelde. Hier wordt de melding van de server als toast
 * getoond en blijft de sessie staan.
 *
 * Staat als los onderdeel ín `ToastProvider` (App.tsx), omdat `AuthProvider`
 * daarbuiten zit en `useToast` daar niet kan gebruiken.
 *
 * Spec: _bmad-output/implementation-artifacts/spec-fix-rolbepaling-app-scope.md, punt 5.
 */
import { useEffect, useRef } from 'react';
import { useToast } from '../../components/Toast';
import { clearRoleNotAssignedCallback, setRoleNotAssignedCallback } from '../../lib/api';

/** Niet vaker dan eens per zoveel ms dezelfde melding stapelen. */
const REPEAT_WINDOW_MS = 8000;

export function RoleNotAssignedNotice() {
  const { showToast } = useToast();
  const lastShownAt = useRef(0);

  useEffect(() => {
    setRoleNotAssignedCallback((message) => {
      const now = Date.now();
      if (now - lastShownAt.current < REPEAT_WINDOW_MS) return;
      lastShownAt.current = now;
      showToast(message, 'error', { duration: REPEAT_WINDOW_MS });
    });
    return () => clearRoleNotAssignedCallback();
  }, [showToast]);

  return null;
}
